import { render, staticRenderFns } from "./Fechamento.vue?vue&type=template&id=6a8cdad0&scoped=true"
import script from "./Fechamento.vue?vue&type=script&lang=js"
export * from "./Fechamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8cdad0",
  null
  
)

export default component.exports